import { render, staticRenderFns } from "./deviceRole.vue?vue&type=template&id=363c8d02&"
import script from "./deviceRole.vue?vue&type=script&lang=js&"
export * from "./deviceRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports